import { createContext } from "react";

import { UserContextType } from "utils/types";

const UserContext = createContext<UserContextType | null>(null);

export default UserContext;
